import type {
  SearchErpPartsByPartNumberQueryKey,
  UseSearchErpPartsByPartNumberParams,
} from './types';

export const getSearchErpPartsByPartNumberQueryKey = (
  params: UseSearchErpPartsByPartNumberParams,
): SearchErpPartsByPartNumberQueryKey => [
  'quotes',
  'importHistoricalWork',
  'searchErpPartsByPartNumber',
  params,
];
